import {createAsyncThunk} from '@reduxjs/toolkit'

import {NAVER_INVOICE_INQUIRY} from '@web/core/urls'
import {changeBrowserLocation} from '@web/helpers/browser'

import {LocationChangeHistoryParam, NavigationResult, ThunkApi} from '../interfaces'

/**
 * 네이버 전자문서 조회 납부 화면 이동
 */
const navigateToInvoiceInquiry = createAsyncThunk<NavigationResult, LocationChangeHistoryParam | void, ThunkApi>(
    'navigateTo/invoiceInquiry',
    async (params) => {
        const {historyType = 'PUSH'} = params ?? {}
        changeBrowserLocation({url: NAVER_INVOICE_INQUIRY, type: historyType})
    },
)

export default navigateToInvoiceInquiry
